import { UpdateUser } from 'domain/usecases/user/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
  BadGateway,
} from 'domain/errors';
import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import 'infra/global/variables';

export class RemoteUpdateUser implements UpdateUser {
  private readonly url: string;

  private readonly httpClient: HttpClient<UpdateUser.Model>;

  constructor(url: string, httClient: HttpClient<UpdateUser.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  update = async (params: UpdateUser.Params): Promise<UpdateUser.Model> => {
    const httpResponse = await this.httpClient.request({
      url: this.url.replace('{userId}', `${params.id}`),
      body: params.body?.avatar ? params.body.avatar : params.body,
      headers: {
        'Content-Type': params?.body?.avatar
          ? 'multipart/form-data'
          : 'application/json',
      },
      method: 'patch',
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
      case HttpStatusCode.accepted:
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      default:
        throw new UnexpectedError();
    }
  };
}
